import { Component, computed, input } from '@angular/core';
import {
  FEATURE_REQUEST_PRIORITY_LABELS,
  type FeatureRequestPriority,
} from '../../../../shared/models/feature-request.models';

@Component({
  selector: 'app-feature-request-priority-badge',
  standalone: true,
  template: `<span [class]="klass()">{{ label() }}</span>`,
})
export class FeatureRequestPriorityBadgeComponent {
  readonly priority = input.required<FeatureRequestPriority>();
  readonly size = input<'sm' | 'md'>('md');

  readonly label = computed(() => FEATURE_REQUEST_PRIORITY_LABELS[this.priority()]);

  readonly klass = computed(() => {
    const priorityClass = `fr-badge--priority-${this.priority().toLowerCase()}`;
    const sizeClass = this.size() === 'sm' ? 'fr-badge--sm' : '';
    return ['fr-badge', priorityClass, sizeClass].filter(Boolean).join(' ');
  });
}
